import { FormComponentProps } from '@ant-design/compatible/lib/form';
import React from 'react';
import { checkEmailExistsInFirebase } from '../../utils/firebase';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Drawer, Input, message, Modal } from 'antd';
import { CREATE_CLIENT_ACCOUNT } from './mutations';
import { getClient } from '../../apollo';

interface IFormComponentProps extends FormComponentProps {
  extraProps: {
    onSubmit: any;
    record: any;
  };
}

interface IFormComponentState {
  loading: boolean;
}

const createClient = async (email: string, password: string, id: string) => {
  // @ts-ignore
  const response = await getClient().mutate({
    mutation: CREATE_CLIENT_ACCOUNT,
    variables: {
      email,
      password,
      id,
    },
  });

  return response.data;
};

class ClientAccountCreationForm extends React.Component<
  IFormComponentProps,
  IFormComponentState
> {
  state = {
    loading: false,
  };

  validatePassword = (
    rule: any,
    value: any,
    callback: { (arg0: string): void; (): void },
  ) => {
    // @ts-ignore
    const { form } = this.props;
    if (form.getFieldValue('password').length < 6) {
      callback(
        'Por favor, utiliza una contraseña que contenga como mínimo 6 caracteres',
      );
    } else {
      callback();
    }
  };

  validateEmail = async (
    rule: any,
    value: any,
    callback: (arg0?: string) => void,
  ) => {
    // @ts-ignore
    const { form } = this.props;

    const valid = /.+@.+\..+/.test(form.getFieldValue('email'));

    if (!valid) {
      callback('Por favor, utiliza un correo electrónico válido');
    } else {
      const emailExists = await checkEmailExistsInFirebase(
        form.getFieldValue('email'),
      );
      if (emailExists) {
        callback('Ya existe un cliente con ese email');
      } else {
        callback();
      }
    }
  };

  handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { email, password } = values;
        const { id } = this.props.extraProps.record;
        try {
          this.setState({
            loading: true,
          });
          message.loading(
            {
              content: 'Dando acceso..',
              key: 'client_create',
            },
            0,
          );

          await createClient(email, password, id);
          message.success(
            {
              content: 'Hecho!',
              key: 'client_create',
            },
            4,
          );
          this.props.extraProps.onSubmit(true);
        } catch (error) {
          console.error('Error creating client', error);
          message.error(
            {
              content: 'Error al dar acceso al cliente',
              key: 'client_create',
            },
            4,
          );
          this.props.extraProps.onSubmit(false);
        } finally {
          this.setState({
            loading: false,
          });
          setTimeout(() => {
            message.destroy();
          }, 2000);
        }
      }
    });
  };

  render() {
    // @ts-ignore
    const { getFieldDecorator } = this.props.form;

    return (
      <Form
        id={'create-client-account-form'}
        onSubmit={this.handleSubmit}
        layout="vertical"
        hideRequiredMark
      >
        <Form.Item label="Correo electrónico">
          {getFieldDecorator('email', {
            rules: [
              {
                required: true,
                message: 'Por favor, introduce un correo electrónico',
              },
              {
                validator: this.validateEmail,
              },
            ],
          })(<Input placeholder={'ejemplo@email.com'} />)}
        </Form.Item>

        <Form.Item label="Contraseña">
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message:
                  'Por favor, introduce una contraseña son 6 carácteres o más',
              },
              {
                validator: this.validatePassword,
              },
            ],
          })(<Input placeholder="Contraseña" />)}
        </Form.Item>
      </Form>
    );
  }
}

export const MyClientAccountCreationForm = Form.create<IFormComponentProps>()(
  ClientAccountCreationForm,
);

export default class CreateClientAccountModal extends React.Component<
  {
    visible: boolean;
    record: any;
    hideModal: () => void;
  },
  {
    creating: boolean;
  }
> {
  state = {
    creating: false,
  };

  onSubmit = (success: boolean) => {
    this.setState({
      creating: false,
    });
    this.props.hideModal();
  };

  render() {
    return (
      <div>
        <Modal
          footer={[
            <Button onClick={() => this.props.hideModal()}>Cerrar</Button>,
            <Button
              onClick={() => {
                this.setState({
                  creating: true,
                });
              }}
              loading={this.state.creating}
              form="create-client-account-form"
              key="submit"
              htmlType="submit"
              type={'primary'}
            >
              Crear cuenta
            </Button>,
          ]}
          title="Crear cuenta en Web Panel"
          centered={true}
          width={300}
          destroyOnClose={true}
          maskClosable={true}
          onCancel={this.props.hideModal}
          visible={this.props.visible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          {
            // @ts-ignore
            // @ts-nocheck
            <MyClientAccountCreationForm
              extraProps={{
                record: this.props.record,
                onSubmit: this.onSubmit,
              }}
            />
          }
        </Modal>
      </div>
    );
  }
}
